<script setup lang="ts">
import {useWindowSize} from "@vueuse/core";

const {isMobile} = useDevice();
const route = useRoute();
const getRouteBaseName = useRouteBaseName();

const {width} = useWindowSize();
// On SSR width is 0, so fall back to user-agent detection.
// On the client it tracks actual window width and reacts to resize.
const showMobileNav = computed(() => isMobile || (width.value > 0 && width.value < 900));

// BreadcrumbList JSON-LD for whichever page the layout is wrapping. Here
// rather than in each page so a new page is covered by adding one line to
// BREADCRUMB_LABEL_KEYS; the home page and /dev/test resolve to no trail.
useBreadcrumbSchema();

// Floating nav needs some extra space except for in the landing page
const isAtLandingPage = computed(() => getRouteBaseName(route) === 'index');
const usePaddingTop = computed(() => !isAtLandingPage.value && !showMobileNav.value);
</script>

<style>
.layout-container {
  width: 100%;
}
</style>

<template>
  <div class="layout-container">
    <a href="#main-content" class="skip-link">{{ $t('skipToContent') }}</a>

    <header>
      <LazyNavigationBarMobileNav v-if="showMobileNav"/>
      <LazyNavigationBarNav v-else/>
    </header>

    <main id="main-content" :class="{'pad-top': usePaddingTop}">
      <slot />
    </main>

    <Footer/>
  </div>
</template>
